<template>
  <span class="webfont"><slot/></span>
</template>

<script>
export default {
  name: 'Webfont',
}
</script>

<style lang="scss" scoped>
@font-face {
  font-family: 'webfontalibaba';
  src: url('~@/webfonts/Alibaba-PuHuiTi-Medium.otf') format('truetype');
}
.webfont {
  font-family: 'webfontalibaba';
  display: inline-block;
  letter-spacing: 2px;
}
</style>